import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "../auth";
import { fetchHasuraToken } from "../service/hasuraTokenService";

// Guard component for private routes
const RequireAuth = ({ children }) => {
  const location = useLocation();
  const authed = Boolean(isAuthenticated());
  if (!authed) {
    try {
      const token = fetchHasuraToken(true);
      if (token) {
        return children;
      }

      if (!token) {
        return <Navigate to="/" replace state={{ from: location }} />;
      }
    } catch (error) {
      return <Navigate to="/" replace state={{ from: location }} />;
    }
  }
  return children;
};

export default RequireAuth;
